import createDOMPurify from 'dompurify';

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'a', 'p', 'br', 'ul', 'ol', 'li', 'span', 'img', 'video', 'source'];
// class + data-list: Quill 2 lists rely on li[data-list=ordered|bullet] and span.ql-ui markers.
const ALLOWED_ATTR = [
  'href', 'target', 'rel', 'src', 'alt', 'controls', 'preload', 'poster', 'type',
  'muted', 'playsinline', 'width', 'height', 'class', 'data-list',
  'contenteditable', 'data-image-type-id', 'data-name', 'data-width', 'data-height', 'data-category',
];

// Own instance: addHook is global, and notifications/clipboard cards use the shared default one.
const DOMPurify = createDOMPurify(window);

// Quill sets these on links it creates; pasted or imported HTML would otherwise open in-tab.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Single XSS boundary: content is stored raw, so every display path sanitizes here.
export function sanitizeHtml(html) {
  if (html == null) {
    return '';
  }
  return DOMPurify.sanitize(String(html), { ALLOWED_TAGS, ALLOWED_ATTR });
}

export function htmlIsEmpty(html) {
  const clean = sanitizeHtml(html);
  if (/<(img|video)\b/i.test(clean) || /data-image-type-id=/i.test(clean)) {
    return false;
  }
  return clean.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === '';
}

// Runs after sanitizeHtml, so only allow-listed block tags (p, li) reach the regex.
export function htmlToText(html) {
  const withBreaks = sanitizeHtml(html)
    .replace(/<\/(p|li)>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n');
  const tmp = document.createElement('div');
  tmp.innerHTML = withBreaks;
  return (tmp.textContent || '').replace(/\n{2,}/g, '\n').trim();
}
